import {
  CardTitleAndSubtitleContainer,
  WeeklyActivityTitleContainer,
} from 'components/DashboardCards/cardStyles';
import TaskSummaryCard from 'components/DashboardCards/taskSummaryCard';
import { t } from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { DashboardCardTitle } from 'styledComponents/dashboard';

import BarChart from '../../components/BarChart/BarChart';
import BarChartSingle from '../../components/BarChart/BarChartSingle';
import TaskProgressOverview from '../../components/DashboardCards/TaskProgressOverview';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import ReactDateRangePicker from '../../components/ReactDateRangePicker/ReactDateRangePicker';
import { ColoredText, PageTitle } from '../../styledComponents/common';
import {
  BillingTooltip,
  BillingTooltipText,
} from '../../styledComponents/createProject';
import {
  DashboardCardContainer,
  DashboardCardsContainer,
  DashboardPageContent,
  DashboardPageHeader,
  DateRangeContainer,
  DateRangeTooltip,
  SmallCardContainer,
  TitleAndModeSelectorDiv,
} from '../Dashboard/dashboardStyles';

const getTime = time => {
  let timeInSeconds = parseInt(time);
  let minutes = Math.floor(timeInSeconds / 60) % 60;
  let hours = Math.floor(timeInSeconds / 3600);

  return `${hours}h ${minutes}m`;
};

const DateRangeSection = ({ startDate, endDate, year }) => {
  return (
    <DateRangeContainer>
      <ColoredText type="blue" fontSize="12px">
        {startDate} - {endDate}, {year}
      </ColoredText>
      <DateRangeTooltip>
        ?
        <BillingTooltip top="32px" left="-230px">
          <BillingTooltipText>
            This is the Organization’s weekly data that starts every Monday and
            ends next Sunday.
          </BillingTooltipText>
        </BillingTooltip>
      </DateRangeTooltip>
    </DateRangeContainer>
  );
};
// Please note that today's data is not included here - this text has been removed

const Dashboard = ({
  location,
  history,
  getDashboardStatus,
  getDashboardTaskProgress,
  getDashboardPerformance,
  getDashboardLateCount,
  getDashboardTopLowPerformers,
  getDashboardUserAnalytics,
  // dashboardData,
  employeeStatusIsloading,
  employee_status,
  taskProgressIsLoading,
  task_progress_overview,
  performanceComparisonIsLoading,
  performance_comparison,
  lateCountIsloading,
  late_count_comparison,
  topLowPerformersIsLoading,
  top_low_performers,
  task_Summary,
  taskSummaryIsLoading,
  getDashboardTaskSummary,
  getDashboardEvaluationSummary,
  evaluationSummaryIsLoading,
  evaluationSummary,
}) => {
  const userRole = localStorage.getItem('user_role');
  const [evaluationDateRange, setEvaluationDateRange] = useState({
    startDate: moment('2026-04-18'),
    endDate: moment()
  });

  useEffect(() => {
    if (userRole === 'admin' || userRole === 'gm' || userRole === 'agm') {
      const payload = {
        date: moment(new Date()),
      };
      getDashboardStatus();
      // getDashboardLateCount();
      // getDashboardTopLowPerformers();
      getDashboardPerformance();
    }
    getDashboardTaskProgress();
    getDashboardTaskSummary();

    // Get evaluation summary with initial date range
    if (userRole ==='admin'){
    fetchEvaluationSummary();
    }
  }, []);

  const fetchEvaluationSummary = () => {
    if (evaluationDateRange.startDate && evaluationDateRange.endDate) {
      getDashboardEvaluationSummary({
        summary_only: true,
        start_date: evaluationDateRange.startDate.format('YYYY-MM-DD'),
        end_date: evaluationDateRange.endDate.format('YYYY-MM-DD'),
      });
    }
  };

  const handleEvaluationDateChange = dateRange => {
    setEvaluationDateRange(dateRange);
  };

  const handleEvaluationDateSelect = () => {
    if (evaluationDateRange.startDate && evaluationDateRange.endDate) {
      getDashboardEvaluationSummary({
        summary_only: true,
        start_date: evaluationDateRange.startDate.format('YYYY-MM-DD'),
        end_date: evaluationDateRange.endDate.format('YYYY-MM-DD'),
      });
    }
  };

  const selectLastMonth = () => {
    const dateRange = {
      startDate: moment().subtract(29, 'days'),
      endDate: moment(),
    };
    setEvaluationDateRange(dateRange);
    getDashboardEvaluationSummary({
      summary_only: true,
      start_date: dateRange.startDate.format('YYYY-MM-DD'),
      end_date: dateRange.endDate.format('YYYY-MM-DD'),
    });
  };

  const selectLastWeek = () => {
    const dateRange = {
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
    };
    setEvaluationDateRange(dateRange);
    getDashboardEvaluationSummary({
      summary_only: true,
      start_date: dateRange.startDate.format('YYYY-MM-DD'),
      end_date: dateRange.endDate.format('YYYY-MM-DD'),
    });
  };

  return (
    <div className="content">
      <DashboardPageHeader>
        <TitleAndModeSelectorDiv>
          <PageTitle style={{ marginBottom: '0' }}>{t('Dashboard')}</PageTitle>
        </TitleAndModeSelectorDiv>
      </DashboardPageHeader>
      <DashboardPageContent marginTop="20px">
        {/* <DashboardPerformanceReportContainer
          marginTop={'20px'}
          padding={'15px 20px 20px'}
          laptopColumns={'1fr'}
          gutter={'2%'}
        >
          <TopPerformanceCard />
          <LowPerformanceCard />
        </DashboardPerformanceReportContainer> */}
        {/* <DashboardCardContainer
          columns="1fr 1fr 1fr 1fr"
          tabletColumns="1fr 1fr"
          mobileColumns="1fr"
          marginTop="20px"
        >
          {performanceComparisonIsLoading ? (
            <>
              <SmallCardContainer>
                <ComponentCircleLoader padding="5vh" />
              </SmallCardContainer>
              <SmallCardContainer>
                <ComponentCircleLoader padding="5vh" />
              </SmallCardContainer>
              <SmallCardContainer>
                <ComponentCircleLoader padding="5vh" />
              </SmallCardContainer>
            </>
          ) : (
            performance_comparison &&
            Object.keys(performance_comparison).length > 0 &&
            performance_comparison.today &&
            performance_comparison.yesterday && (
              <>
                {performance_comparison.today.completed !== undefined &&
                performance_comparison.yesterday.completed !== undefined ? (
                  <TotalCompletedTask
                    completed_today={performance_comparison.today.completed}
                    completed_yesterday={
                      performance_comparison.yesterday.completed
                    }
                  />
                ) : null}
                {performance_comparison.today.partially_complete !==
                  undefined &&
                performance_comparison.yesterday.partially_complete !==
                  undefined ? (
                  <TotalIncompleteTask
                    incomplete_today={performance_comparison.today.partially_complete}
                    incomplete_yesterday={
                      performance_comparison.yesterday.partially_complete
                    }
                  />
                ) : null}
                {performance_comparison.today.missed !== undefined &&
                performance_comparison.yesterday.missed !== undefined ? (
                  <TotalMissedTask
                    missed_today={performance_comparison.today.missed}
                    missed_yesterday={performance_comparison.yesterday.missed}
                  />
                ) : null}
              </>
            )
          )}

          <TotalLateTask late_today="-" late_yesterday="-" />
        </DashboardCardContainer> */}
        <DashboardCardsContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
          background="white"
          padding="20px"
          columnGap="0px"
        >
          <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
            <CardTitleAndSubtitleContainer>
              <DashboardCardTitle>
                {t('overall_information')}
              </DashboardCardTitle>
            </CardTitleAndSubtitleContainer>
          </WeeklyActivityTitleContainer>
          <DashboardCardContainer
            columns="1fr 1fr 1fr 1fr"
            laptopColumns="1fr 1fr 1fr"
            tabletColumns="1fr 1fr"
            mobileColumns="1fr"
          >
            {taskSummaryIsLoading || employeeStatusIsloading ? (
              <>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
                <SmallCardContainer>
                  <ComponentCircleLoader padding="5vh" />
                </SmallCardContainer>
              </>
            ) : (
              <>
                {employee_status &&
                  userRole !== 'supervisor' &&
                  userRole !== 'employee' && (
                    <>
                      <TaskSummaryCard
                        history={history}
                        title={'total_employees'}
                        value={
                          employee_status.online_employees +
                          employee_status.offline_employees
                        }
                      />
                      <TaskSummaryCard
                        history={history}
                        title={'working_today'}
                        value={employee_status.online_employees}
                      />
                      <TaskSummaryCard
                        history={history}
                        title={'not_working_today'}
                        value={employee_status.offline_employees}
                      />
                    </>
                  )}
                {task_Summary && (
                  <>
                    <TaskSummaryCard
                      history={history}
                      title={'all_tasks'}
                      value={task_Summary.total}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'to_do'}
                      value={task_Summary.to_do}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'in_progress'}
                      value={task_Summary.in_progress}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'partially_complete'}
                      value={task_Summary.partially_complete}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'totally_missed'}
                      value={task_Summary.totally_missed}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'complete'}
                      value={task_Summary.complete}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'pending_approval'}
                      value={task_Summary.pending_approval}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'approved'}
                      value={task_Summary.approved}
                    />
                    <TaskSummaryCard
                      history={history}
                      title={'rejected'}
                      value={task_Summary.rejected}
                    />
                    <TaskSummaryCard
                        history={history}
                        title={'not_completed'}
                        value={task_Summary.not_completed}
                    />
                  </>
                )}
              </>
            )}
          </DashboardCardContainer>
        </DashboardCardsContainer>
        {userRole !== 'supervisor' && userRole !== 'employee' && (
          <DashboardCardContainer
            columns="1fr"
            laptopColumns="1fr"
            tabletColumns="1fr"
            marginTop="20px"
          >
            {/* <EmployeeActivityCard
            employee_status={employee_status}
            isLoading={employeeStatusIsloading}
          /> */}
            <TaskProgressOverview
              task_progress_overview={task_progress_overview}
              isLoading={taskProgressIsLoading}
              history={history}
            />
          </DashboardCardContainer>
        )}
        <DashboardCardContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
        >
          <DashboardCardsContainer
            columns="1fr"
            laptopColumns="1fr"
            tabletColumns="1fr"
            background="white"
            padding="20px"
            rowGap="0px"
          >
            {/* <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
              <CardTitleAndSubtitleContainer>
                <DashboardCardTitle>
                  {t('task_progress_by_office')}
                </DashboardCardTitle>
              </CardTitleAndSubtitleContainer>
            </WeeklyActivityTitleContainer> */}

            {taskProgressIsLoading ? (
              <ComponentCircleLoader padding="5vh" />
            ) : task_progress_overview &&
              Array.isArray(task_progress_overview) &&
              task_progress_overview.length > 0 ? (
              <BarChart
                data={task_progress_overview.map(office => ({
                  office: office.office,
                  complete: office.complete || 0,
                  partially_complete: office.partially_complete || 0,
                  to_do: office.to_do || 0,
                  totally_missed: office.totally_missed || 0, // Note: mapping 'missed' to 'totally_missed'
                  in_progress: office.in_progress || 0,
                  not_completed: office.not_completed || 0,
                }))}
                isLoading={taskProgressIsLoading}
                xAxisLabel={t('offices')}
              />
            ) : (
              <NoDataComponent
                title={t('no_data')}
                padding="5vh 0"
                imageHeight="140px"
              />
            )}
          </DashboardCardsContainer>
        </DashboardCardContainer>
        {userRole === 'admin' && (
        <DashboardCardContainer
          columns="1fr"
          laptopColumns="1fr"
          tabletColumns="1fr"
          marginTop="20px"
        >
          <DashboardCardsContainer
            columns="1fr"
            laptopColumns="1fr"
            tabletColumns="1fr"
            background="white"
            padding="20px"
            rowGap="0px"
          >
            <WeeklyActivityTitleContainer margin="0 0 10px 0" padding="0">
              <CardTitleAndSubtitleContainer>
                <div style={{ marginLeft: 'auto', zIndex: '100 !important' }}>
                  <ReactDateRangePicker
                    startDate={evaluationDateRange.startDate}
                    startDateId="evaluation-date-range-start-date"
                    endDate={evaluationDateRange.endDate}
                    endDateId="evaluation-date-range-end-date"
                    onDatesChange={handleEvaluationDateChange}
                    onDateSelect={handleEvaluationDateSelect}
                    dateDisplayFormat="DD/MM/YYYY"
                    selectLastWeek={selectLastWeek}
                    selectLastMonth={selectLastMonth}
                  />
                </div>
              </CardTitleAndSubtitleContainer>
            </WeeklyActivityTitleContainer>

            {evaluationSummaryIsLoading ? (
              <ComponentCircleLoader padding="5vh" />
            ) : evaluationSummary &&
              Array.isArray(evaluationSummary) &&
              evaluationSummary.length > 0 ? (
              <BarChartSingle
                data={evaluationSummary}
                isLoading={evaluationSummaryIsLoading}
                xAxisLabel={t('offices')}
              />
            ) : (
              <NoDataComponent
                title={t('no_evaluation_data_found')}
                padding="5vh 0"
                imageHeight="140px"
              />
            )}
          </DashboardCardsContainer>
        </DashboardCardContainer>)}
      </DashboardPageContent>
    </div>
  );
};

export default Dashboard;
